import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ServicesService } from './../../services/services.service';

@Component({
  selector: 'app-services-block',
  templateUrl: './services-block.component.html',
  styleUrls: ['./services-block.component.less']
})
export class ServicesBlockComponent implements OnInit {

	public data: object = {};
	private inscription: Subscription;

	constructor(private _service: ServicesService) { }

	ngOnInit() {
		this.inscription = this._service.listAllRand(4)
		.subscribe(
			response => {
				this.data['itens'] = response;
			},
			error => {
				console.error ( error );
			}
		);
	}

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/shared/services-block/services-block.component.ts